import { format } from "date-fns";

import { DateFormat } from "@/constants/DateFormat";
import { ScheduleTestID } from "@/constants/TestID";
import { Text } from "@/ui/core";
import { Box } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { joinTestIDs } from "@/utils/string.util";

interface ScheduleEventsListTitleProps {
  title: string;
}

const baseTestID = ScheduleTestID.ScheduleEventsList;

const ScheduleEventsListTitle = ({ title }: ScheduleEventsListTitleProps) => {
  const today = format(new Date(), DateFormat.weekDayMonthDay);
  const isToday = title === today;

  return (
    <Box
      backgroundColor={ColorToken.NeutralBackgroundPrimary}
      paddingBottom={12}
    >
      {isToday ? (
        <Text
          color={ColorToken.Primary100}
          testID={joinTestIDs(baseTestID, "today")}
          variant="bodyMedium"
        >
          Today
        </Text>
      ) : (
        <Text testID={joinTestIDs(baseTestID, "date")} variant="bodyMedium">
          {title}
        </Text>
      )}
    </Box>
  );
};

export default ScheduleEventsListTitle;
